import { type Theme } from '@emotion/react';
import styled from '@emotion/styled';

export const CardTagWidget = styled.span<{ $tone?: keyof Theme['selectionPill']['tones'] }>`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 999px;
  color: ${(p) => p.theme.selectionPill.tones[p.$tone ?? 'interface'].accent};
  background: ${(p) => p.theme.selectionPill.tones[p.$tone ?? 'interface'].background};
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;

  &::before {
    content: '';
    width: 5px;
    height: 5px;
    flex-shrink: 0;
    border-radius: 50%;
    background: currentColor;
  }
`;
